import { HTMLAttributes, useEffect, useId, useRef } from 'react';
import ComparatorLogo from '@/resources/comparator/logos/icon.svg?component';

type ComparatorIconProps = HTMLAttributes<SVGElement>;

export function ComparatorIcon(props: ComparatorIconProps) {
  const elementRef = useRef<SVGElement>(null);
  const randomID = useId();

  useEffect(() => {
    const linearGradient = elementRef.current?.querySelector(
      'linearGradient'
    ) as unknown as HTMLElement;

    const graph = elementRef.current?.querySelector(
      '#small-icon-gradient'
    ) as HTMLElement;

    if (linearGradient) linearGradient.id = randomID;
    if (graph) graph.style.fill = `url(#${randomID})`;
  }, [randomID]);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return <ComparatorLogo {...props} ref={elementRef} />;
}
